<template>
  <Editor v-model='content' :api-key='getTinyKey' :init='finalConfig' :disabled="readonly" />
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import TinyConfig from '@/assets/scripts/tinyConfig';

export default {
  name: 'tiny-editor',
  components: {
    Editor,
  },
  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: [Boolean, String],
      required: false,
      default: false,
    },
    // NEW: Accept custom configuration overrides
    init: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      content: this.value,
    };
  },
  computed: {
    finalConfig() {
      const baseConfig = TinyConfig.getConfig(this.type);

      return { ...baseConfig, ...this.init };
    },
    getTinyKey() {
      return TinyConfig.getAPIKey();
    },
  },
  watch: {
    value(newValue) {
      if (newValue !== this.content) {
        this.content = newValue;
      }
    },

    content(newValue) {
      this.$emit('update', newValue);
    }
  }
};
</script>